import { render, staticRenderFns } from "./InvoiceCategoryCreateEdit.vue?vue&type=template&id=19968545&scoped=true&"
import script from "./InvoiceCategoryCreateEdit.vue?vue&type=script&lang=js&"
export * from "./InvoiceCategoryCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceCategoryCreateEdit.vue?vue&type=style&index=0&id=19968545&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19968545",
  null
  
)

export default component.exports